import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
export default function About() {
    const { t } = useTranslation();
    return (_jsxs("section", { className: "prose", children: [_jsx("h1", { children: t('about.title') }), _jsx("p", { children: t('about.body') })] }));
}
